import { ReviewStatus } from "@redotech/redo-review-db-schema/review";
import { ReviewFieldDbParser } from "@redotech/redo-review-db-schema/review-db-parser";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const upsertReview = {
  name: "upsertReview" as const,
  input: z.object({
    status: createEnum(ReviewStatus),
    shopifyProductId: z.string().min(1),
    shopifyVariantId: z.string().optional(),
    customer: z.optional(
      z.object({
        email: z
          .string()
          .email()
          .transform((val) => val.toLowerCase().trim()),
      }),
    ),
    reviewFields: z.array(ReviewFieldDbParser),
    existingReviewId: zExt.objectId().optional(),
    orderId: zExt.objectId().optional(),
  }),
  output: z.object({ reviewId: z.string() }),
};
